var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 9C11.107 9 6.55349 11.7165 3.53615 15.4472C3.27221 15.7735 3.27221 16.2265 3.53615 16.5528C6.55349 20.2835 11.107 23 16 23C20.8929 23 25.4464 20.2835 28.4638 16.5528C28.7277 16.2265 28.7277 15.7735 28.4638 15.4472C25.4464 11.7165 20.8929 9 16 9ZM1.20358 13.5606C4.64616 9.30416 9.99427 6 16 6C22.0057 6 27.3538 9.30416 30.7964 13.5606C31.9502 14.9872 31.9502 17.0128 30.7964 18.4394C27.3538 22.6958 22.0057 26 16 26C9.99427 26 4.64616 22.6958 1.20358 18.4394C0.0497334 17.0128 0.0497334 14.9872 1.20358 13.5606Z",
    fill: "#C2C2C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 18C17.1045 18 18 17.1046 18 16C18 14.8954 17.1045 14 16 14C14.8954 14 14 14.8954 14 16C14 17.1046 14.8954 18 16 18ZM16 21C18.7614 21 21 18.7614 21 16C21 13.2386 18.7614 11 16 11C13.2385 11 11 13.2386 11 16C11 18.7614 13.2385 21 16 21Z",
    fill: "#C2C2C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibleIcon);
export default __webpack_public_path__ + "static/media/visible-icon.82c30bd2af73e385f6b7378863da4244.svg";
export { ForwardRef as ReactComponent };